import { Controller } from 'stimulus'

export default class extends Controller {
  initialize() {
    // Set newsletter input value to current URL (previously this was done in the template but
    // prevented caching the footer globally)
    this.element.value = window.location.href
  }
}
